// extracted by mini-css-extract-plugin
module.exports = {"Grid":"RVBundlePage_Grid__QRcGG","Header":"RVBundlePage_Header__vmlcr","SendIcon":"RVBundlePage_SendIcon__aMZTG","ValidationIcon":"RVBundlePage_ValidationIcon__xM+Re"};